import React from 'react';
import { HiOutlineArrowRight } from 'react-icons/hi';

/**
 * ArrowRightIcon
 * Ikona šípky smerom doprava na označenie akcií posunu vpred.
 */
const ArrowRightIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineArrowRight className={className} {...props} />
);

export default ArrowRightIcon;

